import React from 'react';
import { get } from 'lodash';

export const getCardFlag = (cardnumber) => {
  const _cardnumber = cardnumber.replace(/[^0-9]+/g, '');

  const cards = {
    Visa: /^4[0-9]{12}(?:[0-9]{3})/,
    master: /^5[1-5][0-9]{14}/,
    Diners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}/,
    Amex: /^3[47][0-9]{13}/,
    Discover: /^6(?:011|5[0-9]{2})[0-9]{12}/,
    Hipercard: /^(606282\d{10}(\d{3})?)|(3841\d{15})/,
    Elo: /^((((636368)|(438935)|(504175)|(451416)|(636297))\d{0,10})|((5067)|(4576)|(4011))\d{0,12})/,
    JCB: /^(?:2131|1800|35\d{3})\d{11}/,
    Aura: /^(5078\d{2})(\d{2})(\d{11})$/,
  };

  for (var flag in cards) {
    if (cards[flag].test(_cardnumber)) {
      return flag;
    }
  }

  return false;
};

export const tableTextFilterMethod = (filter, row) => {
  const { id, value } = filter;
  const text = row[id].toString().toUpperCase();
  const search = value.toUpperCase();
  return text.includes(search);
};

export const formatCPF = (d) => {
  const cpf = get(d, 'original.cpf', '');

  if (cpf) {
    const formated_cpf = cpf.replace(/(-)|(\.)/g, '');
    return (
      <em>
        {formated_cpf.substring(0, 3)}.{formated_cpf.substring(3, 6)}.
        {formated_cpf.substring(6, 9)}-{formated_cpf.substring(9, 11)}
      </em>
    );
  }
  return null;
};

export const formatCurrency = (value) =>
  value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
export const convertCurrencyValue = (value) =>
  +value.replace('R$', '').replace('.', '').replace(',', '.');

export default tableTextFilterMethod;
